import * as Types from '../../_generated/types.d';

import { GeocodeResponseData } from "@googlemaps/google-maps-services-js";
import { CoachState } from "@portal/app/_common/lib/coach";
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
export type AttemptAddDreamSearchClickEventMutationVariables = Types.Exact<{
  data: Types.DreamSearchClickEventCreateInput;
}>;


export type AttemptAddDreamSearchClickEventMutation = { __typename?: 'Mutation', attemptAddDreamSearchClickEvent: { __typename?: 'MarketplaceEvent', id: string, customerId: string | null } };


export const AttemptAddDreamSearchClickEventDocument = gql`
    mutation attemptAddDreamSearchClickEvent($data: DreamSearchClickEventCreateInput!) {
  attemptAddDreamSearchClickEvent(data: $data) {
    id
    customerId
  }
}
    ` as unknown as DocumentNode<AttemptAddDreamSearchClickEventMutation, AttemptAddDreamSearchClickEventMutationVariables>;